export default __webpack_public_path__ + "static/media/Clown-auf-Rad.a24909ec.png";